import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';

import { VideoWidget } from '@website-builder/widgets/video/video-widget';
import { Row } from '@website-builder/model/structure/row/row';
import { SectionStyle } from '@website-builder/model/structure/section/section-style';
import { EditableComponent } from '@website-builder/model/structure/editable-component.interface';
import { BuilderElementPosition } from '@website-builder/model/structure/builder-element-position';
import { makeEntityId } from '@website-builder/util/make-widget-id.utility';
import { EntityIdPrefix } from '@website-builder/model/domain/entity-id-prefix.enum';
import { WidgetNormalizer } from '@website-builder/widgets/normalizer/widget-normalizer';
import { BuilderRootStructureType } from '@website-builder/model/state/builder-root-structure.type';

export class Section implements EditableComponent {
  readonly type: BuilderElementType.Section = BuilderElementType.Section;
  builderElementPosition: BuilderElementPosition;
  sideTitle = '';
  id = makeEntityId(EntityIdPrefix.SECTION);
  rows = new Array<Row>();
  name = 'Section';
  src: string;
  video: VideoWidget;
  style = new SectionStyle();
  parentType: BuilderRootStructureType;

  static normalizeInPlace(section: Partial<Section>): Section {
    const pureSection = new Section();

    section.sideTitle = section.sideTitle ?? pureSection.sideTitle;
    section.id = section.id ?? pureSection.id;
    section.rows = (section.rows ?? []).map(row => Row.normalizeInPlace(row));
    section.name = section.name ?? pureSection.name;
    section.src = section.src ?? pureSection.src;
    section.video = section.video
      ? (WidgetNormalizer.normalizeInPlace(section.video) as VideoWidget)
      : pureSection.video;
    section.style = SectionStyle.normalize(section.style);
    section.parentType = section.parentType ?? pureSection.parentType;

    return section as Section;
  }
}
